import { MenuItem, Typography } from '@mui/material';
import InstallDesktopIcon from '@mui/icons-material/InstallDesktop';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../constants/routes';
import { isInstalledApp, isPhoneOrTablet } from '../../utils/installApp';

// "Get the desktop app" in the account menu: the download page, which also
// offers installing from the browser. Hidden on phones (the phone app is
// better there) and inside the app itself.
const InstallAppMenuItem = ({ onClose, textStyle }) => {
  const navigate = useNavigate();
  if (isInstalledApp() || isPhoneOrTablet()) return null;

  return (
    <MenuItem onClick={() => { onClose?.(); navigate(AppRoutes.DesktopApp); }}>
      <InstallDesktopIcon />
      <Typography variant="body2" sx={textStyle}>
        Get the desktop app
      </Typography>
    </MenuItem>
  );
};

export default InstallAppMenuItem;
